import _ from 'lodash';
import { EventTypes } from 'redux-segment';
import * as at from './actionTypes';
import {
  entriesDelete,
  entriesUpdate,
  tagsUpdateOnEntries
} from 'data/actions';
import { makeDebugger } from 'lib';

const debug = makeDebugger('scenes/Main/actions');

export const cleanUp = () => {
  return { type: at.UNMOUNTING }
}

export const tagFilterUpdate = (tags) => {
  return {
    type: at.TAG_FILTER_UPDATE,
    payload: tags
  }
}

export const searchTextUpdate = (text) => {
  return {
    type: at.SEARCH_TEXT_UPDATED,
    payload: text
  }
}

export const handleCancelEditing = () => {
  return {
    type: at.CANCEL_EDITING
  }
}

export const entrySelected = (id) => {
  return {
    type: at.ENTRY_SELECTED,
    payload: id
  }
}

export const entryUnselected = (id) => {
  return {
    type: at.ENTRY_UNSELECTED,
    payload: id
  }
}

export const entriesOpened = (entryIds, method) => {
  return {
    type: at.ENTRIES_OPENED,
    meta: {
      analytics: {
        eventType: EventTypes.track,
        eventPayload: {
          event: 'Entry Opened',
          properties: {
            number_entries: entryIds.length,
            entry_ids: entryIds,
            method: method
          }
        }
      }
    }
  }
}

export const groupsSelected = (groups) => {
  return {
    type: at.GROUP_SELECTED,
    payload: groups
  }
}

export const changeReadFilter = (filter) => {
  return {
    type: at.TOGGLE_SHOW_READ,
    payload: filter
  }
}

export const toggleSortOrder = () => {
  return {
    type: at.TOGGLE_SORT_ORDER
  }
}

export const handleDoneEditing = () => {
  return {
    type: at.DONE_EDITING
  }
}

export const toggleAddModal = (open) => {
  return {
    type: at.TOGGLE_ADD_MODAL,
    payload: open
  }
}

// Helper
const getTagsInCommon = (entries) => {
  if (entries.length === 0) return [];
  const firstEntry = entries[0];
  if (!firstEntry.tags || firstEntry.tags.length === 0) return [];
  return _.reduce(entries, (tagsInCommon, entry) => {
    return _.intersection(tagsInCommon, entry.tags)
  }, firstEntry.tags)
}

const getTagsForEntries = (entryIds, entries) => {
  return _.map(entryIds, (id) => {
    return { id, tags: entries[id].tags };
  })
}

export const tagsUpdatedInSelection = (newTags, tagsSelected) => {
  return (dispatch, getState) => {
    debug("updating tags: ", newTags);
    dispatch({ type: at.TAGS_UPDATED_IN_SELECTION, payload: newTags });
    const selectedEntries = getState().scene.main.entriesSelected;
    const entries = getState().data.entries;
    const tagsInCommon = getTagsInCommon(getTagsForEntries(selectedEntries, entries));
    const tagsToAdd = _.difference(newTags, tagsInCommon);
    const tagsToRemove = _.difference(tagsInCommon, newTags);
    dispatch(tagsUpdateOnEntries(selectedEntries, tagsToAdd, tagsToRemove));
  }
}

export const handleMarkAsRead = (isRead) => {
  return (dispatch, getState) => {
    const entryIds = getState().scene.main.entriesSelected;
    const changes = [];
    const dateRead = isRead ? '' : new Date();
    for (let id of entryIds) changes.push({id, data: { isRead, dateRead}});
    dispatch(entriesUpdate(changes));
    dispatch({ type: at.DONE_WITH_SELECTION })
  }
}

export const entriesRemove = () => {
  return (dispatch, getState) => {
    const entriesSelected = getState().scene.main.entriesSelected;
    const entries = getState().data.entries;
    dispatch({ type: at.DONE_EDITING })
    dispatch(entriesDelete(getTagsForEntries(entriesSelected, entries)));
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Main/actions.js